import { Link } from '@hotjar/hotsauce';
import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getLabels } from '../../../../utils/LabelFormatter/SingleLabelFormatter/RageClickLabelFormatter';
import { getFilterMetadata } from '../../FilterChainUtils';
import { GenericRadioFilter } from '../GenericBloc/GenericRadioFilter/GenericRadioFilter';
import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { OPTION_LIST } from './RageClickFilterConstant';
import type { RAGE_CLICK_TYPE } from './RageClickFilterType';

export function RageClickFilter({
  currentValue,
  autoFocus,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
}: AbstractSingleFilterPillsProps<RAGE_CLICK_TYPE>): JSX.Element {
  const metadata = getFilterMetadata(FilterKindEnum.RageClickKind);
  const { label1, label2 } = getLabels(currentValue);
  return (
    <GenericRadioFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      iconName={metadata.iconName}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      optionList={OPTION_LIST}
      label1={label1}
      label2={label2}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
      header={
        <span>
          Sessions with users who clicked or tapped repeatedly out of frustration.{' '}
          <Link kind="inline" href="https://www.hotjar.com/blog/rage-clicks/" isExternal>
            More about rage clicks
          </Link>
        </span>
      }
    />
  );
}
